/* eslint-disable */
import {
  memoEval,
  sceneEntityObjectPropertiesComponent,
  sceneEntityObjectRemoteMaterialOverrideComponent,
  sceneEntityRemoteObjectComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { attachComponent } from '../implementation.js'

export const apronBasicComponents = [
  attachComponent
    .withComponent(sceneEntityRemoteObjectComponent, 'apron', true)
    .withEntity('ApronBasic')
    .withGradualFilter({ active: self => self.$apronFilter })
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.$fileUrl, self.$objectName],
        ($fileUrl, $objectName) => ({
          fileUrl: $fileUrl,
          objectName: $objectName,
          dimensionUnit: 'inch',
        })
      )
    ),

  attachComponent
    .withComponent(sceneEntityObjectPropertiesComponent, 'apron', true)
    .withEntity('ApronBasic')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$offsetY,
            self.$length,
            self.$lengthScaleZero,
            self.$lengthScaleOne,
            self.$width,
            self.$widthScaleZero,
            self.$widthScaleOne,
            self.$thickness,
            self.$thicknessScaleZero,
            self.$thicknessScaleOne,
            self.$stretch,
            self.$stretchScaleZero,
            self.$stretchScaleOne,
          ],
        (
          $offsetY,
          $length,
          $lengthScaleZero,
          $lengthScaleOne,
          $width,
          $widthScaleZero,
          $widthScaleOne,
          $thickness,
          $thicknessScaleZero,
          $thicknessScaleOne,
          $stretch,
          $stretchScaleZero,
          $stretchScaleOne
        ) => ({
          offsetY: $offsetY,
          morphTargetInfluences: {
            length: {
              value: $length,
              scaleZero: $lengthScaleZero,
              scaleOne: $lengthScaleOne,
            },
            width: {
              value: $width,
              scaleZero: $widthScaleZero,
              scaleOne: $widthScaleOne,
            },
            depth: {
              value: $thickness,
              scaleZero: $thicknessScaleZero,
              scaleOne: $thicknessScaleOne,
            },
            stretch: {
              value: $stretch,
              scaleZero: $stretchScaleZero,
              scaleOne: $stretchScaleOne,
            },
          },
        })
      )
    ),

  attachComponent
    .withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'apron', true)
    .withEntity('ApronBasic')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$fileUrl,
            self.$finishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$materialRoughness,
            self.$materialMetalness,
            self.$materialEnvMapIntensity,
            self.$materialSpecularIntensity,
            self.$materialNormalScale,
            self.$materialReflectivity,
            self.$repeatX,
            self.$repeatY,
          ],
        (
          $fileUrl,
          $finishColor,
          $textureUrl,
          $normalMapUrl,
          $roughnessMapUrl,
          $aoMapUrl,
          $materialRoughness,
          $materialMetalness,
          $materialEnvMapIntensity,
          $materialSpecularIntensity,
          $materialNormalScale,
          $materialReflectivity,
          $repeatX,
          $repeatY
        ) => ({
          materialsToOverride: ['ApronMaterial'],
          fileUrl: $fileUrl,
          materialName: 'ApronMaterial',
          color: $finishColor,
          textureUrl: $textureUrl,
          normalMapUrl: $normalMapUrl,
          roughnessMapUrl: $roughnessMapUrl,
          aoMapUrl: $aoMapUrl,
          roughness: $materialRoughness,
          metalness: $materialMetalness,
          envMapIntensity: $materialEnvMapIntensity,
          specularIntensity: $materialSpecularIntensity,
          normalScale: $materialNormalScale,
          reflectivity: $materialReflectivity,
          repeatX: $repeatX,
          repeatY: $repeatY,
        })
      )
    ),
]
